// Do not edit the generated JSON. Source: backend/app/core/access_policy.json.
import policy from './access-policy.generated.json'

export type Role = keyof typeof policy.roles
export type LegacyRole = keyof typeof policy.legacy_aliases
export type StoredRole = Role | LegacyRole
export type Permission = keyof typeof policy.permissions
export const ACCESS_POLICY = policy
export const POLICY_VERSION = policy.version

export function normalizeRole(value: unknown): Role | null {
  if (typeof value !== 'string') return null
  const raw = value.trim().toLowerCase()
  const aliases: Record<string, string> = policy.legacy_aliases
  const role = Object.prototype.hasOwnProperty.call(aliases, raw) ? aliases[raw] : raw
  return Object.prototype.hasOwnProperty.call(policy.roles, role) ? role as Role : null
}

export function hasPermission(value: unknown, permission: Permission): boolean {
  const role = normalizeRole(value)
  return !!role && (policy.roles[role].permissions as string[]).includes(permission)
}

export function roleLabel(value: unknown): string {
  const role = normalizeRole(value)
  return role ? policy.roles[role].label : '身份待确认'
}

export function homeForRole(value: unknown): { path: string; name: string } {
  const role = normalizeRole(value)
  return role
    ? { path: policy.roles[role].home_path, name: policy.roles[role].home_route }
    : { path: '/login', name: 'Login' }
}

export function assignableRolesFor(value: unknown): Role[] {
  const role = normalizeRole(value)
  // Global-teacher accounts cannot be downgraded or created by this editor.
  return role && !hasPermission(role, 'users.manage')
    ? policy.assignable_roles as Role[]
    : []
}
